module.exports = __webpack_public_path__ + "img/4-5.e653a3f6.svg";